import { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import React from 'react';
import { NewsLetterService } from '../../Services/NewsLetterService';
import { IEmailAddressInscription } from '../../Models';

interface INewsLetterInscriptionWidgetState {
    emailAddressInscription: IEmailAddressInscription;
    isSuccess: boolean;
    showAlert: boolean;
}

interface INewsLetterInscriptionWidgetProps {
    area: string;
    dictEmailAddress: string;
    dictSearch: string;
    dictError: string;
    dictSuccess: string;
}

export class NewsLetterInscriptionWidget extends Component<
    INewsLetterInscriptionWidgetProps,
    INewsLetterInscriptionWidgetState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            emailAddressInscription: {
                emailAddress: null,
                area: this.props.area,
            },
            showAlert: false,
            isSuccess: false,
        };

        this.InscriptionMailList = this.InscriptionMailList.bind(this);
    }

    async InscriptionMailList(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (
            this.state.emailAddressInscription &&
            this.state.emailAddressInscription.emailAddress
        ) {
            const errorCode = await NewsLetterService.InscriptionMailList(
                this.state.emailAddressInscription
            );
            this.setState({
                showAlert: true,
                isSuccess: errorCode == 0 ? true : false,
            });
        }
    }

    handleEmailAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
        const email = this.state.emailAddressInscription;
        email.emailAddress = event.target.value;
        this.setState({ emailAddressInscription: email });
    };

    render() {
        return (
            <>
                <form
                    className="form-group-with-button"
                    onSubmit={(e) => {
                        void this.InscriptionMailList(e);
                    }}
                    data-skip-captcha="true"
                >
                    <div className="form-group">
                        <label className="sr-only sr-only-focusable">
                            {this.props.dictEmailAddress}
                        </label>
                        <div className="search">
                            <label htmlFor="emailAddress" className="sr-only">
                                {this.props.dictEmailAddress}
                            </label>
                            <input
                                id="emailAddress"
                                type="email"
                                placeholder={this.props.dictEmailAddress}
                                value={
                                    this.state.emailAddressInscription
                                        .emailAddress
                                        ? this.state.emailAddressInscription
                                              .emailAddress
                                        : ''
                                }
                                onChange={this.handleEmailAddress}
                            />
                        </div>
                    </div>
                    <div className="form-group submit">
                        <button type="submit">
                            <i className="icon-send"></i>
                            {this.props.dictSearch}
                        </button>
                    </div>
                </form>
                {this.state.showAlert && this.state.isSuccess && (
                    <div
                        className="alert alert-success alert-dismissible fade show"
                        role="alert"
                    >
                        {this.props.dictSuccess}
                    </div>
                )}
                {this.state.showAlert && !this.state.isSuccess && (
                    <div
                        className="alert alert-danger alert-dismissible fade show"
                        role="alert"
                    >
                        {this.props.dictError}
                    </div>
                )}
            </>
        );
    }
}

WidgetHelper.register(
    NewsLetterInscriptionWidget,
    'news-letter-inscription-widget'
);
